export default (x) => (x instanceof Array ? x : [x]);
//# sourceMappingURL=ensurePlural.mjs.map